import findLastIndex from 'lodash/findLastIndex';
import { RootState } from 'src/store/store';
import { AnyRequestBaseStoreEntityType } from 'src/store/types';

export const anyRequestSelector =
  (id: string) =>
  ({ anyRequest }: RootState): AnyRequestBaseStoreEntityType => {
    // find the last item to use the latest given response
    const found = findLastIndex(anyRequest, ({ uniqueId }) => uniqueId === id);

    if (~found) {
      const { loading, response, uniqueId, error } = anyRequest[found];

      return {
        loading,
        response,
        uniqueId,
        error,
      };
    }

    return {
      loading: false,
      response: null,
      uniqueId: '',
      error: null,
    };
  };
